import React from "react";
import { observer } from "mobx-react";
import { StationShuffleEditTemplate } from "themes/administration/shuffle/pages";
import { StationShuffleEditViewStore } from "administration/shuffle/stores";
import { setCurrentView } from "mrb/core";

@setCurrentView(
    (rootStore, componentProps) =>
        new StationShuffleEditViewStore(rootStore, componentProps),
    "stationShuffleEditViewStore"
)
@observer
class StationShuffleEdit extends React.Component {
    render() {
        return <StationShuffleEditTemplate {...this.props} />;
    }
}

export default StationShuffleEdit;
